export class BrazeUser {
    constructor() {       
        this.users = [];
    }
    users: UserExportField[];
    message: string;
}
export class UserExportField {
    external_id: string;
    braze_id: string;
    first_name: string;
    last_name: string;
    dob: string | null;
    email: string;
    push_subscribe: SubscriptionStatus;
    email_subscribe: SubscriptionStatus;
    email_unsubscribed_at: string | null;
    home_city: string;
    phone: string;
    language: string;
}
export enum SubscriptionStatus {
    opted_in,
    unsubscribed,
    subscribed
}